<div
  [attr.id]="module.slug || null"
  [attr.data-ancnav]="module.slug || null"
  class="content-module text-module"
>
  <h3 class="text__title" *ngIf="module.title">{{ module.title }}</h3>
  <app-wysiwyg-content [content]="module.text" *ngIf="module.text"></app-wysiwyg-content>
</div>
